import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { SizesDto } from "./sizes-dto";

export class SizesResponse extends GlobalResponseObject{

      data?: SizesDto;
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, intlCode:number, internalMessage:string, data?: SizesDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.internalMessage = internalMessage;
        this.intlCode = intlCode;
        this.data = data;
    }

}